/* loaded by smart-asset */
export default require("./assets/green-tote.i.svg")